import { mapState } from 'vuex';

export default {
  computed: {
    ...mapState('popup', ['currentPopupOptions']),
  },
};



// WEBPACK FOOTER //
// ./src/components/generics/modal/layouts/generic.js